import {
  App,
  Button,
  Card,
  DatePicker,
  Descriptions,
  Dropdown,
  Flex,
  Input,
  Menu,
  Modal,
  Popconfirm,
  Popover,
  Space,
  Table,
  Tag,
} from 'antd';
import React, { useRef, useState } from 'react';
import {
  MdAssignmentAdd,
  MdDelete,
  MdModeEditOutline,
  MdOutlinePayment,
  MdVisibility,
} from 'react-icons/md';
import { useSelector } from 'react-redux';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  AddbulkAction,
  AddcreditNote,
  addSalesInvoice,
  deleteSalesInvoice,
  downloadZatca,
  downloadZatcaXml,
  getPDF,
  getSalesInvoices,
  getZatcaDetails,
  submitSalesInvoice,
  submitToZatca,
} from '../../network/salesInvoice';
import { queryKeys } from '../../services/react-query/queryKeys';
import { useNavigate } from 'react-router-dom';
import {
  FaFileInvoiceDollar,
  FaFilePdf,
  FaMoneyBillWave,
} from 'react-icons/fa';
import {
  ModalAppPayment,
  ModalAppPdfData,
  ModalTodoList,
} from '../../components/upeosoft/ModalApp/ModalApp';
import DetailsInvoiceNumber from '../../components/common/DetailsInvoiceNumber/DetailsInvoiceNumber';
import StatusTag from '../../hooks/StatusHook';
import UseDownloadPdf from '../../hooks/DownloadPdf';
import { GiFiles } from 'react-icons/gi';
import {
  CheckOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  DownloadOutlined,
  DownOutlined,
  EditOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { colorPrimary } from '../../utils/utils';
import { TiCancel } from 'react-icons/ti';
import {
  cancelMaterialRequest,
  submitMaterialRequest,
} from '../../network/materialRequest';
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';
import { FaMoneyBillTrendUp } from 'react-icons/fa6';
import { TbDotsVertical } from 'react-icons/tb';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import { IoIosArrowRoundBack, IoIosArrowRoundForward } from 'react-icons/io';
import DashboardCards from '../Dashboard/DashboardCards';
const SalesInvoiceTable = ({ t }) => {
  const { currentLang } = useSelector((state) => state.user);
  const { onGetPDF, pdfData, setLoadingPdf, loadingPdf } = UseDownloadPdf();
  const [openTask, setOpenTask] = useState(false);
  const [idTask, setIdTask] = useState(null);
  const [open, setOpen] = useState(false);
  const [nameInvoice, setNameInvoice] = useState('');
  const [openPdf, setOpenPdf] = useState(false);
  const [nameInvoiceZatca, setNameInvoiceZatca] = useState('');
  const [openPdfZatca, setOpenPdfZatca] = useState(false);
  const [submitToZatcaLoading, setSubmitToZatcaLoading] = useState(false);
  const [editId, setEditId] = useState(null);
  const [total, setTotal] = useState(0);
  const [textValue, setTextValue] = useState('');
  const [searchText, setSearchText] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [zatcaData, setZatcaData] = useState(null);
  // console.log(zatcaData, 'zatcaData');

  const [pageCount, setPageCount] = useState(1);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editIdDrawer, setEditIdDrawer] = useState(null);
  const searchInputMobile = useRef(null);
  const searchInputMobilecustomer = useRef(null);
  const searchInput = useRef(null);
  const searchInputcustomer = useRef(null);
  const client = useQueryClient();
  const [searchKey, setSearchKey] = useState('');
  const [actionType, setActionType] = useState('');
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  // console.log(selectedRowKeys, 'selectedRowKeys');
  const handleSearch = (selectedKeys, confirm, key) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchKey(key);
  };
  const handleReset = (clearFilters, confirm, setSelectedKeys) => {
    confirm();
    setSearchText('');
    setSearchKey('');
    if (clearFilters) {
      clearFilters();
    }
    if (setSelectedKeys) {
      setSelectedKeys(['']);
    }
  };
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getSalesInvoices, currentLang, searchText],
    queryFn: () => getSalesInvoices(searchKey, searchText, currentLang),
    keepPreviousData: true,
  });

  const handleRemove = useMutation({
    mutationFn: (id) => deleteSalesInvoice(id),
    onSuccess: (data) => {
      // console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message);
      // message.success('تم الحذف بنجاح');
      client.invalidateQueries({ queryKey: [queryKeys.getSalesInvoices] });
    },
    onError: () => {
      message.error('حدث خطأ ما');
    },
  });
  const handleCancel = useMutation(
    // (id) => deletePatient(id),
    {
      // cancelMaterialRequest
      mutationFn: (name) => cancelMaterialRequest('Sales Invoice', name),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success('Cancelled successfully');
        client.invalidateQueries({ queryKey: [queryKeys.getSalesInvoices] });
      },
      onError: () => {
        message.error('Something went wrong!');
      },
    }
  );
  const { mutate: onAddSalesInvoice } = useMutation({
    mutationKey: ['addSalesInvoice'],
    mutationFn: (body) => addSalesInvoice(body),
    onSuccess: (data) => {
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success('Credit note added successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesInvoices],
      });
    },

    onError: (error) => {
      console.log('error:', error);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const handleCreditNote = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (name) => AddcreditNote(name),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        if (data?.message) {
          onAddSalesInvoice(data?.message);
        } else {
          message.error('Something went wrong!');
        }
      },
      onError: () => {
        message.error('Something went wrong!');
      },
    }
  );
  const { mutate: onSubmitSalesInvoice } = useMutation({
    mutationKey: ['submitSalesInvoice'],
    mutationFn: (name) => submitMaterialRequest('Sales Invoice', name),
    onSuccess: (data) => {
      //  console.log(data, 'data');
      console.log(data?.message, 'data');
      //  console.log(data?.message?.status, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      data?.message?.message && message.success(data?.message?.message);
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesInvoices],
      });
    },
    onError: (error) => {
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { mutate: onSubmitToZatca } = useMutation({
    mutationKey: ['submitToZatca'],
    mutationFn: (name) => submitToZatca(name),
    onSuccess: (data) => {
      //  console.log(data, 'data');
      setSubmitToZatcaLoading(false);
      console.log(data?.message, 'data');
      //  console.log(data?.message?.status, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      // data?.message?.message && message.success(data?.message?.message);
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesInvoices],
      });
    },
    onError: (error) => {
      setSubmitToZatcaLoading(false);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { mutate: onDownloadZatca, data: pdfDataZatca } = useMutation({
    mutationKey: ['downloadZatca'],
    mutationFn: ({ type, name, lang, format }) =>
      downloadZatca({ type, name, lang, format }),
    onSuccess: (data) => {
      console.log(data, 'data onDownloadZatca');
      console.log(data?.message, 'data');
      //  console.log(data?.message?.status, 'data');
      setLoadingPdf(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      // message.success('Download successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesInvoices],
      });
    },
    onError: (error) => {
      setLoadingPdf(false);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { mutate: onGetZatcaDetails } = useMutation({
    mutationKey: ['getZatcaDetails'],
    mutationFn: (name) => getZatcaDetails(name),
    onSuccess: (data) => {
      const msg = data?.message?.[0];
      let validationResults = [];
      if (msg?.status === 500) {
        message.error(msg?.message);
        return;
      }

      // setZatcaData({
      //   status: msg?.status,
      //   zatca_status: msg?.zatca_status,
      //   validationResults: JSON.parse(msg?.zatca_message),
      // });
      // const parsedMessage = JSON.parse(msg.zatca_message);
      const parsedMessage = msg?.zatca_message?.split('\n');
      const results = parsedMessage?.validationResults ?? {};

      const allMessages = [
        ...(Array.isArray(results.infoMessages) ? results.infoMessages : []),
        ...(Array.isArray(results.warningMessages)
          ? results.warningMessages
          : []),
        ...(Array.isArray(results.errorMessages) ? results.errorMessages : []),
      ];

      // validationResults = allMessages.map((item) => ({
      //   type: item.type,
      //   message: item.message,
      // }));
      setZatcaData({
        status: msg?.status,
        zatca_status: msg?.zatca_status,
        validationResults: parsedMessage,
      });
      setModalOpen(true);
    },
    onError: (error) => {
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { mutate: onDownloadZatcaXml } = useMutation({
    mutationKey: ['downloadZatcaXml'],
    mutationFn: (name) => downloadZatcaXml(name),
    // onSuccess: (response, name) => {
    //   const blob = new Blob([response.data], { type: 'application/xml' });
    //   const url = URL.createObjectURL(blob);
    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.download = `invoice-${name}.xml`;
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    //   URL.revokeObjectURL(url);

    //   message.success('Download successfully');
    //   client.invalidateQueries({
    //     queryKey: [queryKeys.getSalesInvoices],
    //   });
    // },
    // onSuccess: (response, name) => {
    //   console.log('XML Content:', response.data.slice(0, 100));

    //   const blob = new Blob([response.data], { type: 'application/xml' });
    //   const url = URL.createObjectURL(blob);
    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.download = `invoice-${name}.xml`;
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    //   URL.revokeObjectURL(url);

    //   message.success('Download successfully');
    //   client.invalidateQueries({
    //     queryKey: [queryKeys.getSalesInvoices],
    //   });
    // },
    onSuccess: (response, name) => {
      const xmlContent = response.data;

      console.log('First 100 XML Chars:', xmlContent.slice(0, 100));

      const blob = new Blob([xmlContent], {
        type: 'application/xml;charset=utf-8',
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `invoice-${name}.xml`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      message.success('Download successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesInvoices],
      });
    },
    onError: (error) => {
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });

  const { mutate: onAddbulkAction } = useMutation({
    mutationKey: ['AddbulkAction'],
    mutationFn: (selectNames) =>
      AddbulkAction('Sales Invoice', actionType, selectNames),
    onSuccess: (data) => {
      console.log(data?.message, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      setSelectedRowKeys([]);
      message.success(
        actionType === 'cancel' ? 'Cancel successfully' : 'Submit successfully'
      );
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesInvoices],
      });
    },
    onError: (error) => {
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });

  const onSelectChange = (newSelectedRowKeys) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(dataTable);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Table Data');

    XLSX.writeFile(workbook, 'table_data.xlsx');
  };
  const items = (record) => [
    {
      key: '1',
      // label: record?.docstatus === 0 ? t.Edit : t.view,
      label: t.Edit + ' ' + t.salesInvoice,
      icon: <MdModeEditOutline />,
      onClick: () => navigate(`/sales-invoice/${record?.name}`),
    },
    {
      key: '2',
      label: t.Payment,
      icon: <MdOutlinePayment />,
      disabled: record.status === 'Paid' ? true : false,
      onClick: () => {
        setOpen(true);
        setEditId(record?.name);
        setTotal(record?.outstanding_amount);
      },
    },
    {
      key: '3',
      label: t.paymentEntry,
      icon: <FaMoneyBillWave />,
      disabled: record.status === 'Paid' ? true : false,
      // record.status === 'Draft'
      //   ? false
      //   : record.status === 'Overdue'
      //   ? false
      //   : true,
      onClick: () => navigate(`/payment-entry/sales/${record?.name}`),
    },
    {
      key: '4',
      label: t.GeneralLedger,
      icon: <GiFiles />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => navigate(`/general-ledger-report-sales/${record?.name}`),
    },
    {
      key: '5',
      label: t.SubmittheSalesInvoice,
      disabled: record.status === 'Draft' ? false : true,
      icon: <CheckOutlined />,
      onClick: () => onSubmitSalesInvoice(record?.name),
    },
    {
      type: 'divider',
    },
    {
      key: '5-1',
      label: t.SubmitToZatca,
      // disabled: record.status === 'Draft' ? false : true,

      icon: <CheckOutlined />,
      onClick: () => {
        setSubmitToZatcaLoading(true);
        onSubmitToZatca(record?.name);
      },
    },
    {
      key: '5-2',
      label: t.downloadZatcaPdf,
      // disabled: record.status === 'Draft' ? false : true,

      icon: <DownloadOutlined />,
      onClick: () => {
        onDownloadZatca({
          // type: 'Sales Invoice',
          name: record?.name,
          lang: currentLang,
          format: '',
        });
        setNameInvoiceZatca(record.name);
        setOpenPdfZatca(true);
      },
    },
    {
      key: '5-3',
      label: t.downloadZatcaXML,
      // disabled: record.status === 'Draft' ? false : true,

      icon: <DownloadOutlined />,
      onClick: () => onDownloadZatcaXml(record?.name),
    },
    {
      key: '5-4',
      label: t.GetZatcaDetails,
      // disabled: record.status === 'Draft' ? false : true,

      icon: <CheckOutlined />,
      onClick: () => onGetZatcaDetails(record?.name),
    },
    {
      key: '6',
      label: t.getPDF,
      icon: <CheckOutlined />,
      onClick: () => {
        onGetPDF({
          type: 'Sales Invoice',
          name: record.name,
          lang: currentLang,
        });
        setNameInvoice(record.name);
        setOpenPdf(true);
      },
    },
    {
      key: '7',
      label: t.CreditNote,
      disabled: record?.docstatus === 1 ? false : true,
      icon: <FaMoneyBillTrendUp />,
      onClick: () => handleCreditNote.mutate(record.name),
    },
    {
      key: '8',
      label: t.CanceltheSalesInvoice,
      icon: <CloseCircleOutlined />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => handleCancel.mutate(record?.name),
    },
    {
      key: '77',
      label: t.AssignTask,
      icon: <MdAssignmentAdd />,
      onClick: () => {
        setOpenTask(true);
        setIdTask(record?.name);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '9',
      disabled: record?.docstatus === 1 ? true : false,
      label: (
        <Popconfirm
          title={t.DeletetheSalesInvoice + ` (${record?.name})`}
          okText={t.yes}
          cancelText={t.no}
          onConfirm={() => handleRemove.mutate(record?.name)}
        >
          <span style={{ color: 'red' }}>{t.Delete}</span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: currentLang === 'en' ? 'Invoice Number' : 'رقم الفاتورة',
      dataIndex: 'name',
      // filteredValue: [searchText],
      // onFilter: (value, record) => {
      //   const name = String(record.name).toLowerCase();
      //   const searchValue = value.toLowerCase();
      //   // console.log(record);
      //   return name.includes(searchValue);
      // },
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInputMobile}
            placeholder={
              currentLang === 'en' ? 'Invoice Number' : 'رقم الفاتورة'
            }
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            onPressEnter={() => handleSearch(selectedKeys, confirm, 'name')}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => {
                handleSearch(selectedKeys, confirm, 'name');
                setSearchKey('name');
              }}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters, confirm)}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText('');
          setSearchKey('');
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              navigate(`/sales-invoice/${record.name}`);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: currentLang === 'en' ? 'customer' : 'العميل',
      dataIndex: 'customer',
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInputMobilecustomer}
            placeholder={currentLang === 'en' ? 'customer' : 'العميل'}
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            onPressEnter={() => handleSearch(selectedKeys, confirm, 'customer')}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => {
                handleSearch(selectedKeys, confirm, 'customer');
                setSearchKey('customer');
              }}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters, confirm)}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText('');
          setSearchKey('');
          setTimeout(() => searchInputcustomer.current?.select(), 100);
        }
      },
    },
    {
      title: currentLang === 'en' ? 'Date' : 'تاريخ',
      dataIndex: 'posting_date',
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Flex vertical gap={16}>
            <DatePicker
              onChange={(date) => {
                console.log(date, 'e.target.value');
                // console.log(e, 'e.target.value');
                console.log(
                  dayjs(date)?.format('YYYY-MM-DD'),
                  'appointment_date'
                );
                if (date) {
                  setSearchKey('posting_date');
                  setSelectedKeys(
                    date ? [dayjs(date)?.format('YYYY-MM-DD')] : []
                  );
                  setTextValue(dayjs(date)?.format('YYYY-MM-DD'));
                  setSearchText(dayjs(date)?.format('YYYY-MM-DD'));
                } else {
                  setSearchKey('');
                  setSelectedKeys('');
                  setTextValue('');
                  setSearchText('');
                }
              }}
            />
          </Flex>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText('');
          setSearchKey('');
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
      // render: (text, record) => {
      //   return (
      //     <span
      //       style={{ cursor: 'pointer' }}
      //       className="text-primary"
      //       onClick={() => {
      //         navigate(`/sales-invoice/${record.name}`);
      //       }}
      //     >
      //       {text}
      //     </span>
      //   );
      // },
    },
    {
      title: currentLang === 'en' ? 'Total' : 'المجموع',
      dataIndex: 'base_grand_total',
    },
    {
      title: currentLang === 'en' ? 'Outstanding Amount' : 'المبلغ المستحق',
      dataIndex: 'outstanding_amount',
    },
    {
      title: t.status,
      dataIndex: 'status',
      render: (status) => <StatusTag status={status} />,
      filterIcon: () => <SearchOutlined color={colorPrimary} />,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInputMobile}
            placeholder={currentLang === 'en' ? 'status' : 'الحالة'}
            value={textValue}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              setTextValue(e.target.value);
            }}
            onPressEnter={() => handleSearch(selectedKeys, confirm, 'status')}
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => {
                handleSearch(selectedKeys, confirm, 'status');
                setSearchKey('status');
              }}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Search}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters, confirm)}
              size="small"
              style={{
                width: 90,
              }}
            >
              {t.Reset}
            </Button>
          </Space>
        </div>
      ),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTextValue('');
          setSearchText('');
          setSearchKey('');
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    {
      title: t.action,
      dataIndex: 'docstatus',
      key: 'docstatus',
      width: 150,
      // align: 'center',
      render: (text, record) => {
        const enable_submit = record.status === 'Draft' ? true : false;
        const enable_payment_entry = record.status === 'Draft' ? true : false;
        const enable_payment =
          record.status === 'Unpaid'
            ? true
            : record.status === 'Partly Paid'
            ? true
            : false;

        return (
          <Space>
            <Dropdown
              menu={{ items: items(record) }}
              trigger={['click']}
              overlayClassName="custom-dropdown"
              // placement="bottomCenter"
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: item?.name,
      ...item,
    };
  });
  const { total_count, total_pages } = data?.message?.pagination || {};

  return (
    <div className="sales-invoice">
      {/* <Heading title={t.Finance} subTitle={t.salesInvoice} path="/" /> */}
      {/* <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        titleBtn={t.AddSalesInvoice}
        Placeholder={t.searchSalesInvoice}
        pathBtn="/sales-invoice/add"
        totalCount={total_count}
        totalPages={total_pages}
        setPageCount={setPageCount}
        pageCount={pageCount}
        rowSelection={rowSelection}
      /> */}
      <DashboardCards t={t} />
      <Card className="mt-5">
        <Space
          style={{
            width: '100%',
            marginBottom: 16,
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
          wrap
        >
          <Input.Search
            placeholder={t.searchSalesInvoice}
            onSearch={(value) => setSearchText(value)}
            onChange={(value) => setSearchText(value.target.value)}
            style={{ width: 200 }}
            allowClear
            className="search-input-ant"
            prefix={<SearchOutlined />}
          />
          <Flex align="center" gap={10}>
            {/* <Button type="primary" onClick={handleDownload} >
        Download 
      </Button> */}
            <Dropdown
              overlayClassName="custom-dropdown"
              menu={{
                items: [
                  {
                    label: t.export,
                    key: '1',
                    onClick: exportToExcel,
                  },
                  {
                    label: t.submit,
                    key: '2',
                    onClick: () => {
                      setActionType('submit');
                      onAddbulkAction(selectedRowKeys);
                    },
                    disabled: !selectedRowKeys?.length,
                  },
                  {
                    label: t.cancel,
                    key: '3',
                    onClick: () => {
                      setActionType('cancel');
                      onAddbulkAction(selectedRowKeys);
                    },
                    disabled: !selectedRowKeys?.length,
                  },
                ],
              }}
            >
              {/* <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              /> */}
              {/* <Button type="primary" onClick={exportToExcel}> */}
              <Button type="primary">{t.export}</Button>
            </Dropdown>
            <Button
              type="primary"
              onClick={() => navigate('/sales-invoice/add')}
            >
              <PlusOutlined size={10} /> {t.AddSalesInvoice}
            </Button>
          </Flex>
        </Space>
        <Table
          className="table_custom"
          columns={columns}
          dataSource={dataTable}
          scroll={{ x: 'max-content' }}
          // className="table"
          loading={isLoading || submitToZatcaLoading}
          style={{ margin: '15px 0' }}
          // pagination={{
          //   current: pageCount,
          //   total: total_count,
          //   pageSize: 10,
          // }}
          pagination={{
            pageSize: 10,
            current: pageCount,
            total: total_count,
            hideOnSinglePage: true,
            showSizeChanger: false,
            // align: 'center',
            itemRender: (current, type, originalElement) => {
              if (type === 'prev') {
                return (
                  <div
                    // onClick={handlePrevClick}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      order: 1,
                    }}
                  >
                    <IoIosArrowRoundForward
                      size={16}
                      style={{
                        transform:
                          currentLang === 'en'
                            ? 'rotate(180deg)'
                            : 'rotate(0deg)',
                      }}
                    />
                    <span>{t.prev}</span>
                  </div>
                );
              }
              if (type === 'next') {
                return (
                  <div
                    // onClick={handleNextClick}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      order: -1,
                    }}
                  >
                    <span> {t.next}</span>
                    <IoIosArrowRoundBack
                      size={16}
                      style={{
                        transform:
                          currentLang === 'en'
                            ? 'rotate(180deg)'
                            : 'rotate(0deg)',
                      }}
                    />
                  </div>
                );
              }
              return originalElement;
            },
            // onChange: (page) => {
            //   setFilterData({ ...filterData, page });
            // },
          }}
          rowSelection={rowSelection}
          onChange={(pagination) => {
            setPageCount(pagination.current);
          }}
        />
      </Card>
      <ModalAppPayment
        open={open}
        setOpen={setOpen}
        editId={editId}
        t={t}
        type="Sales Invoice"
        total={total}
      />
      <ModalAppPdfData
        open={openPdfZatca}
        pdfData={pdfDataZatca}
        setOpen={setOpenPdfZatca}
        nameInvoice={nameInvoiceZatca}
        t={t}
        onGetPDF={onDownloadZatca}
        type="Sales Invoice"
        setLoadingPdf={setLoadingPdf}
        loadingPdf={loadingPdf}
      />
      <ModalAppPdfData
        open={openPdf}
        pdfData={pdfData}
        setOpen={setOpenPdf}
        nameInvoice={nameInvoice}
        t={t}
        onGetPDF={onGetPDF}
        type="Sales Invoice"
        setLoadingPdf={setLoadingPdf}
        loadingPdf={loadingPdf}
      />
      <DetailsInvoiceNumber
        open={openDrawer}
        setOpen={setOpenDrawer}
        editId={editIdDrawer}
        t={t}
      />
      <ModalTodoList
        open={openTask}
        setOpen={setOpenTask}
        editId={idTask}
        doctype="Sales Invoice"
        t={t}
      />
      <Modal
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        footer={null}
        centered
        // title="تفاصيل ZATCA"
        title={t.zatcaDetails}
        width={800}
      >
        {zatcaData && (
          <Descriptions column={1} bordered>
            <Descriptions.Item label={t.status}>
              {/* {zatcaData.status} */}
              <StatusTag status={zatcaData.status} />
            </Descriptions.Item>
            {/* <Descriptions.Item label="حالة ZATCA"> */}
            <Descriptions.Item label={t.zatcaStatus}>
              {zatcaData.zatca_status}
            </Descriptions.Item>
            {/* {zatcaData.validationResults?.map((item, index) => (
              <Descriptions.Item
                label={`${t.message} ${index + 1}`}
                key={index}
              >
                <span
                  style={{
                    color:
                      item.type === 'ERROR'
                        ? 'red'
                        : item.type === 'WARNING'
                        ? 'orange'
                        : 'green',
                  }}
                >
                  {item.message}
                </span>
              </Descriptions.Item>
            ))} */}

            {/* {Array.isArray(zatcaData?.validationResults) &&
              zatcaData.validationResults.map((item, index) => (
                <Descriptions.Item
                  label={`${t.message} ${index + 1}`}
                  key={index}
                >
                  <span
                    style={{
                      color:
                        item.type === 'ERROR'
                          ? 'red'
                          : item.type === 'WARNING'
                          ? 'orange'
                          : 'green',
                    }}
                  >
                    {item.message}
                  </span>
                </Descriptions.Item>
              ))} */}
            <Descriptions.Item label={`${t.message}`}>
              {zatcaData?.validationResults}
              {/* {Array.isArray(zatcaData?.validationResults) &&
                zatcaData.validationResults.map((item, index) => (
                  <span key={index}>{item.message}</span>
                ))} */}
            </Descriptions.Item>

            {/* {zatcaData.validationResults?.infoMessages?.map((item, index) => (
              <Descriptions.Item
                label={`${t.message} ${index + 1}`}
                key={index}
              >
                {item.message}
              </Descriptions.Item>
            ))} */}
          </Descriptions>
        )}
      </Modal>
    </div>
  );
};

export default SalesInvoiceTable;
